import React, { useEffect } from 'react'
import {
  giftCardBannerListQueryOption,
  giftHotDealListQueryOption,
  useCustomQuery,
} from 'src/hooks/react-query/useCustomQuery.hook'
import { BannerSpace, GiftHotDealListsSpace } from 'src/types/api'
import GiftHotDealPageView from 'src/pages/GiftHotDealPage/view'
import RenderIf from 'src/components/common/RenderIf'
import { Loading } from 'src/components/common/Loading'
import { mobileOS } from 'src/utils'
import usePageNav from 'src/hooks/usePageNav.hook'
import { QueryClient } from '@tanstack/react-query'
import { aosOpenApp, iosIntroDeepLink } from 'src/utils/windowOpen'

export interface GiftHotDealPageProps {
  hotDealInProgressList: GiftHotDealListsSpace.GiftHotDealItemType[]
  hotDealInComingList: GiftHotDealListsSpace.GiftHotDealItemType[]
  bannerItem: BannerSpace.BannerType
  openService: () => void
}

export const giftHotDealPageLoader = (queryClient: QueryClient) => async () => {
  const dataQueryValues = [
    await queryClient.ensureQueryData(giftHotDealListQueryOption({ Type: 0 })),
    await queryClient.ensureQueryData(giftHotDealListQueryOption({ Type: 1 })),
    await queryClient.ensureQueryData(giftCardBannerListQueryOption({ Type: 1 })),
  ]
  return Promise.allSettled(dataQueryValues)
}

const GiftHotDealPage = () => {
  const { splashPageNav } = usePageNav()
  const os = mobileOS()

  const {
    data: hotDealInProgressQueryData = { Body: { HotdealCouponByType: Array(3).fill({}) } },
    isLoading: isHotDealInProgressLoading,
  } = useCustomQuery<GiftHotDealListsSpace.Response>(giftHotDealListQueryOption({ Type: 0 }))
  const {
    data: hotDealInComingQueryData = { Body: { HotdealCouponByType: Array(3).fill({}) } },
    isLoading: isHotDealInComingLoading,
  } = useCustomQuery<GiftHotDealListsSpace.Response>(giftHotDealListQueryOption({ Type: 1 }))

  const {
    data: bannerListQueryData = { Body: { banner: Array(3).fill({}) } },
    isLoading: isBannerListLoading,
  } = useCustomQuery<BannerSpace.Response>(giftCardBannerListQueryOption({ Type: 1 }))

  const openService = () => {
    const webUrl = `${process.env.REACT_APP_SERVICE_URL}/web/splash`
    switch (os) {
      case 'android':
        window.location.href = aosOpenApp(webUrl)
        break
      case 'ios':
        window.location.href = iosIntroDeepLink
        break
      default:
        splashPageNav()
        break
    }
  }

  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [])

  const props: GiftHotDealPageProps = {
    hotDealInProgressList: hotDealInProgressQueryData?.Body?.HotdealCouponByType,
    hotDealInComingList: hotDealInComingQueryData?.Body?.HotdealCouponByType,
    bannerItem: bannerListQueryData?.Body?.banner?.[0],
    openService,
  }

  return (
    <React.Fragment>
      <RenderIf
        when={isBannerListLoading || isHotDealInProgressLoading || isHotDealInComingLoading}
      >
        <Loading.Default />
      </RenderIf>
      <GiftHotDealPageView {...props} />
    </React.Fragment>
  )
}

export default GiftHotDealPage
